import React, { useState, useEffect } from 'react';
import "./floating.css"

export default function FloatingAnchorButton() {
  const [isVisible, setIsVisible] = useState(false);

  // Mostra o botão apenas quando o usuário rolar a página para baixo
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Função para rolar suavemente até o topo
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
            className='floatingBtn'
          onClick={scrollToTop}
          aria-label="Rolar para o topo"
        >
          ↑
        </button>
      )}
    </>
  );
}